<template>
	<div class="category-animation-1" :class="{'final':isFinished}">
		<div class="horse">
			<img src="@/assets/animations/1/body.png" class="body">
			<img src="@/assets/animations/1/leg2.png" class="leg2">
			<img src="@/assets/animations/1/leg3.png" class="leg3">
			<img src="@/assets/animations/1/leg4.png" class="leg4">
			<img src="@/assets/animations/1/tail.png" class="tail">
			<img src="@/assets/animations/1/wing.png" class="wing">
			<!--<img src="@/assets/animations/1/palm.png" class="palm">-->
			<div class="leg1">
				<img src="@/assets/animations/1/leg1.png" class="leg1">
				<img src="@/assets/animations/1/crown.png" class="crown">
			</div>

			<div class="palm">
				<img src="@/assets/animations/1/palm1.png" class="palm1">
				<img src="@/assets/animations/1/palm2.png" class="palm2">
				<img src="@/assets/animations/1/palm3.png" class="palm3">
				<img src="@/assets/animations/1/palm4.png" class="palm4">
				<img src="@/assets/animations/1/palm5.png" class="palm5">
				<img src="@/assets/animations/1/palm6.png" class="palm6">
				<img src="@/assets/animations/1/palm7.png" class="palm7">
				<img src="@/assets/animations/1/palm8.png" class="palm8">
				<img src="@/assets/animations/1/palm9.png" class="palm9">
				<img src="@/assets/animations/1/palm10.png" class="palm10">
				<img src="@/assets/animations/1/palm11.png" class="palm11">
			</div>
		</div>

		<div class="candy">
			<img src="@/assets/animations/1/candy.png" class="body">
			<img src="@/assets/animations/1/candy-wing1.png" class="wing1">
			<img src="@/assets/animations/1/candy-wing2.png" class="wing2">
		</div>
	</div>
</template>

<script>
	export default {
		name: "category-animation-1",
		components: {},
		data: () => {
			return {
				isFinished: false,
			}
		},
		methods: {},
		mounted() {
			setTimeout(() => this.isFinished = true, 2000);
		}
	}
</script>

<style lang="scss">
	.category-animation-1 {
		//display: none;

		@include up($md) {
			//height: auto;
			//margin-top: 0;
			z-index: 2;
			position: absolute;

			width: 0;
			//max-width: $lg;
			height: 480px;

			left: 50%;
			top: 0;
			transform: translate(-50%) scale(1);
		}

		img, div {
			position: absolute;
			opacity: 0;
		}

		div {
			&.horse {
				z-index: 2;
				width: 125px;
				height: 268px;
				animation: animHorse 2500ms linear forwards;
				animation-delay: 1000ms;

				img {
					opacity: 1;

					&.body {
						z-index: 2;
						//animation: animHorseBody 1000ms infinite alternate;
						//transform-origin: 50% 0%;
						top: 0;
						left: 0;
					}

					&.leg2 {
						animation: animHorseLeg2  9000ms infinite;
						animation-delay: 5000ms;
						transform: rotate(5deg);
						transform-origin: 0 90%;
						top: 19%;
						left: 84%;
					}

					&.leg3 {
						z-index: 1;
						animation: animHorseLeg3 500ms linear 7 alternate;
						//animation-delay: 500ms;
						transform-origin: 50% 0%;
						top: 60%;
						left: 40%;
					}

					&.leg4 {
						z-index: 3;
						animation: animHorseLeg4 450ms linear 8 alternate;
						transform-origin: 75% 5%;
						top: 64.5%;
						left: -16%;
					}

					&.tail {
						z-index: 1;
						animation: animHorseTail 5000ms infinite alternate;
						transform-origin: 90% 90%;
						top: 30%;
						left: -60%;
					}

					&.wing {
						z-index: 3;
						animation: animHorseWing 250ms infinite alternate;
						transform-origin: 90% 50%;
						top: 42%;
						left: 34%;
					}

					&.palm {
						z-index: 1;
						animation: animHorsePalm 500ms linear 8 alternate;
						transform-origin: 70% 100%;
						top: -34%;
						left: -37%;
					}
				}
			}

			&.palm {
				z-index: 1;
				//animation: animPalm 1200ms linear infinite alternate;
				//animation-delay: 6000ms;
				transform-origin: 0 50%;
				//transform: rotate(-17deg);
				opacity: 1;
				width: 170px;
				height: 150px;
				top: 4%;
				left: -23%;

				//transform: rotateZ(20deg);

				img {
					&.palm1 {
						animation: animPalmLeaf 1000ms infinite alternate;
						transform-origin: 100% 0%;
						z-index: 10;
					}

					&.palm2 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 50ms;
						transform-origin: 100% 0%;
						z-index: 9;
						top: -5%;
						left: -3%;
					}

					&.palm3 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 100ms;
						transform-origin: 100% 100%;
						z-index: 8;
						top: -13%;
						left: -5%;
					}

					&.palm4 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 150ms;
						transform-origin: 100% 100%;
						z-index: 7;
						top: -34%;
						left: -1%;
					}

					&.palm5 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 200ms;
						transform-origin: 100% 100%;
						z-index: 6;
						top: -55%;
						left: 12%;
					}

					&.palm6 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 250ms;
						transform-origin: 100% 100%;
						z-index: 5;
						top: -65%;
						left: 21%;
					}

					&.palm7 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 300ms;
						transform-origin: 0 100%;
						z-index: 6;
						transform: rotateY(180deg) rotateZ(45deg);
						top: -67%;
						left: 36%;
					}

					&.palm8 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 350ms;
						transform-origin: 0 100%;
						//transform: rotateY(180deg) rotateZ(45deg);
						z-index: 7;
						top: -62%;
						left: 46%;
					}

					&.palm9 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 400ms;
						transform-origin: 0 100%;
						//transform: rotateY(180deg) rotateZ(45deg);
						z-index: 8;
						top: -49%;
						left: 46%;
					}

					&.palm10 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 450ms;
						transform-origin: 0 100%;
						//transform: rotateY(180deg) rotateZ(45deg);
						z-index: 9;
						top: -35%;
						left: 46%;
					}

					&.palm11 {
						animation: animPalmLeaf 1000ms infinite alternate;
						animation-delay: 500ms;
						transform-origin: 0 100%;
						//transform: rotateY(180deg) rotateZ(45deg);
						z-index: 10;
						top: -24%;
						left: 47%;
					}
				}
			}

			&.leg1 {
				z-index: 2;
				animation: animHorseLeg1 9000ms infinite;
				animation-delay: 5000ms;
				transform-origin: 0 50%;
				opacity: 1;
				width: 120px;
				height: 110px;
				top: 15%;
				left: 72%;

				img {
					&.leg1 {
						z-index: 2;
						top: 50%;
						left: 0;
					}

					&.crown {
						top: 15%;
						left: 62%;
						transform: rotateY(180deg)
					}
				}
			}

			&.candy {
				z-index: 1;
				width: 190px;
				height: 190px;
				animation: animCandy 1750ms forwards;
				animation-delay: 3500ms;

				img {
					opacity: 1;

					&.body {
						z-index: 1;
						top: 0;
						left: 0;
					}

					&.wing1 {
						z-index: 0;
						animation: animCandyWing1 400ms infinite alternate;
						//animation-delay: 500ms;
						transform-origin: 90% 90%;
						top: -29%;
						left: -3%;
					}

					&.wing2 {
						z-index: 0;
						animation: animCandyWing2 400ms infinite alternate;
						//animation-delay: 500ms;
						transform-origin: 10% 90%;
						top: -15%;
						left: 63%;
					}
				}
			}
		}

		@keyframes animHorse {
			from {
				top: 20%;
				left: -440px;
			}
			25% {
				opacity: 1;
			}
			to {
				opacity: 1;
				top: 20%;
				left: -320px;
			}
		}

		/*@include up($lg) {
			@keyframes animHorse {
				from {
					top: 20%;
					left: -540px;
				}
				25% {
					opacity: 1;
				}
				to {
					opacity: 1;
					top: 20%;
					left: -420px;
				}
			}
		}*/

		@keyframes animHorseLeg1 {
			from {
				transform: rotate(0)
			}
			20% {
				transform: rotate(-17deg)
			}
			80% {
				transform: rotate(-17deg)
			}
			to {
				transform: rotate(0)
			}
		}

		@keyframes animHorseLeg2 {
			from {
				transform: rotate(5deg)
			}
			20% {
				transform: rotate(-12deg)
			}
			80% {
				transform: rotate(-12deg)
			}
			to {
				transform: rotate(5deg)
			}
		}

		@keyframes animHorseLeg3 {
			from {
				transform: rotate(10deg)
			}
			to {
				transform: rotate(0)
			}
		}

		@keyframes animHorseLeg4 {
			from {
				transform: rotate(0)
			}
			to {
				transform: rotate(9deg)
			}
		}

		@keyframes animHorseTail {
			from {
				transform: rotate(-5deg)
			}
			to {
				transform: rotate(5deg)
			}
		}

		@keyframes animHorseWing {
			from {
				transform: rotate(25deg)
			}
			to {
				transform: rotate(0)
			}
		}

		@keyframes animPalmLeaf {
			from {
				transform: rotate(0)
			}
			/*50% {
				transform: rotate(0)
			}
			50% {
				transform: rotate(-4deg)
			}*/
			to {
				transform: rotate(-6deg)
			}
		}

		/*@keyframes animPalmLeaf2 {
			from {
				transform: rotateY(180deg) rotateZ(45deg);
			}
			10% {
				transform: rotateY(180deg) rotateZ(41deg);
			}
			90% {
				transform: rotateY(180deg) rotateZ(41deg);
			}
			to {
				transform: rotateY(180deg) rotateZ(45deg);
			}
		}*/

		@keyframes animCandy {
			from {
				top: 15%;
				left: 300px;
			}
			25% {
				opacity: 1;
			}
			to {
				opacity: 1;
				top: 26%;
				left: 170px;
			}
		}

		/*@include up($lg) {
			@keyframes animCandy {
				from {
					top: 15%;
					left: 400px;
				}
				25% {
					opacity: 1;
				}
				to {
					opacity: 1;
					top: 26%;
					left: 270px;
				}
			}
		}*/

		@keyframes animCandyWing1 {
			from {
				transform: rotate(25deg)
			}
			to {
				transform: rotate(0)
			}
		}

		@keyframes animCandyWing2 {
			from {
				transform: rotate(-25deg)
			}
			to {
				transform: rotate(0)
			}
		}
	}

</style>